angular.module('env.data.models.categoryModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes) {
        restProvider.defineModel("CategoryModel",
            {
                extend: ['BaseModel'],
                url: "category",
                fields: {
                    categoryTypeId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    name: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    archived: {
                        type: RepresentationModelFieldTypes.DATE
                    },
                    categoryType: {
                        subResource: true,
                        type: RepresentationModelFieldTypes.MODEL,
                        get: function (rest, model) {
                            if (model.$model.categoryTypeId) {
                                return rest
                                    .map(rest.getDefinition("CategoryTypeModel"))
                                    .map(model.$model.categoryTypeId)
                                    .willReturn("CategoryTypeModel", model.$model.categoryTypeId)
                                    .get();
                            }
                            return null;
                        }
                    }
                }
            }
        );
    })

;